import { db } from '../../shared/config';
import {
  collection,
  addDoc,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  startAfter,
  endBefore,
  limitToLast,
  limit,
  Timestamp,
  where,
} from 'firebase/firestore';
import {
  GET_CUSTOMERS,
  ADD_CUSTOMER,
  GET_CUSTOMER,
  RESET_CUSTOMER,
  CUSTOMERS_ERROR,
} from '../types/customer_type';

import { setAlert } from './alert';
import { LIMIT } from '../../domain/constant';
//GET CUSTOMERS
const customerssRef = collection(db, 'customers');
export const getCustomers =
  ({ term, termField, orderValue = 'createdAt', orderType = 'desc' }) =>
  async (dispatch) => {
    try {
      let searchQuery = null;
      if (term) {
        searchQuery = query(customerssRef, where(termField, '==', term));
      } else {
        searchQuery = query(
          customerssRef,
          orderBy(orderValue, orderType),
          limit(LIMIT)
        );
      }
      const querySnapshot = await getDocs(searchQuery);
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_CUSTOMERS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
      dispatch(setAlert('Something went wrong', 'danger'));
      dispatch({
        type: CUSTOMERS_ERROR,
      });
    }
  };

export const getNextCustomers =
  ({ term, termField, last, orderValue = 'createdAt', orderType = 'desc' }) =>
  async (dispatch) => {
    try {
      let searchQuery = null;
      if (term) {
        searchQuery = query(
          customerssRef,
          orderBy(orderValue, orderType),
          startAfter(last[orderValue]),
          limit(LIMIT),
          where(termField, '==', term)
        );
      } else {
        searchQuery = query(
          customerssRef,
          orderBy(orderValue, orderType),
          startAfter(last[orderValue]),
          limit(LIMIT)
        );
      }
      const querySnapshot = await getDocs(searchQuery);
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_CUSTOMERS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
      dispatch(setAlert('Something went wrong', 'danger'));
      dispatch({
        type: CUSTOMERS_ERROR,
      });
    }
  };
export const getPreviousCustomers =
  ({ term, termField, first, orderValue = 'createdAt', orderType = 'desc' }) =>
  async (dispatch) => {
    try {
      let searchQuery = null;
      if (term) {
        searchQuery = query(
          customerssRef,
          orderBy(orderValue, orderType),
          endBefore(first[orderValue]),
          limitToLast(LIMIT),
          where(termField, '==', term)
        );
      } else {
        searchQuery = query(
          customerssRef,
          orderBy(orderValue, orderType),
          endBefore(first[orderValue]),
          limitToLast(LIMIT)
        );
      }

      const querySnapshot = await getDocs(searchQuery);
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_CUSTOMERS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
      dispatch(setAlert('Something went wrong', 'danger'));
      dispatch({
        type: CUSTOMERS_ERROR,
      });
    }
  };

export const addCustomer = (data) => async (dispatch) => {
  try {
    data.createdAt = Timestamp.fromDate(new Date());
    const docRef = await addDoc(customerssRef, data);
    dispatch({
      type: ADD_CUSTOMER,
    });
    dispatch(setAlert('Customer added successfully', 'success'));
  } catch (e) {
    console.error('Error adding document: ', e);
    dispatch(setAlert('Something went wrong', 'danger'));
    dispatch({
      type: CUSTOMERS_ERROR,
    });
  }
};

export const getCustomerBySlug = (slug) => async (dispatch) => {
  try {
    dispatch({
      type: RESET_CUSTOMER,
    });
    let searchQuery = null;
    searchQuery = query(customerssRef, where('slug', '==', slug));
    const querySnapshot = await getDocs(searchQuery);
    const data = [];
    querySnapshot.forEach((doc) => {
      data.push({ id: doc.id, ...doc.data() });
    });
    if (data.length > 0) {
      dispatch({
        type: GET_CUSTOMER,
        payload: data[0],
      });
    } else {
      dispatch({
        type: GET_CUSTOMER,
        payload: null,
      });
      dispatch({
        type: CUSTOMERS_ERROR,
      });
    }
  } catch (err) {
    console.log(err);
    dispatch(setAlert('Something went wrong', 'danger'));
    dispatch({
      type: CUSTOMERS_ERROR,
    });
  }
};
export const getCustomer = (id) => async (dispatch) => {
  try {
    dispatch({
      type: RESET_CUSTOMER,
    });
    const docRef = doc(db, 'customerss', id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      data.id = id;
      dispatch({
        type: GET_CUSTOMER,
        payload: data,
      });
    } else {
      dispatch(setAlert('Something went wrong', 'danger'));
      dispatch({
        type: CUSTOMERS_ERROR,
      });
    }
  } catch (err) {
    dispatch(setAlert('Something went wrong', 'danger'));
    dispatch({
      type: CUSTOMERS_ERROR,
    });
  }
};
export const editCustomer = (id, data) => async (dispatch) => {
  try {
    const docSnap = await updateDoc(doc(db, 'customerss', id), data);
    dispatch(setAlert('Customer updated successfully', 'success'));
  } catch (err) {
    dispatch(setAlert('Something went wrong', 'danger'));
    dispatch({
      type: CUSTOMERS_ERROR,
    });
  }
};

export const deleteCustomer = (id) => async (dispatch) => {
  try {
    const docSnap = await deleteDoc(doc(db, 'customerss', id));
    dispatch(setAlert('Customer deleted successfully', 'success'));
  } catch (err) {
    dispatch(setAlert('Something went wrong', 'danger'));
    dispatch({
      type: CUSTOMERS_ERROR,
    });
  }
};
